import { Outlet } from "react-router-dom";
import CsrFooter from "../common-components/CsrFooter";
import Navbar from "../common-components/Navbar";
import React, { useContext } from "react";
import { AppContext } from "../context/Context";
import ScrollToTop from "./ScrollToTop";

const MainLayout = () => {
  const { loading } = useContext(AppContext);

  if (loading) {
    return (
      <div className="vh-100 d-flex flex-column justify-content-center align-items-center">
  <div className="spinner-border text-primary mb-3"></div>
  <h5>Loading CSR Portal...</h5>
</div>
    );
  }
  return (
    <>
        <ScrollToTop />

     <Navbar />
<Outlet />
    <CsrFooter />  
      
    </>
  );
};

export default MainLayout;
